import { serverUrl } from './serverConfig'
import { genericError } from "../util/errorUtil"
export const getPlayerReportApi = async (payload) => {
    try {
        const { playerUid, sessionToken } = payload
        const body = {
            "identity": "user.aca.getuserprogressstats",
            "uid": playerUid
        }
        const playerReport = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await playerReport.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}

export const getPlayerReportByTimeApi = async (payload) => {
    try {
        const { playerUid, sessionToken, startDateTs, endDateTs } = payload
        const body = {
            "identity": "user.aca.getuserprogressstatsbytime",
            "uid": playerUid,
            "startDateTs": startDateTs,
            "endDateTs": endDateTs
        }
        const playerReportByTime = await fetch(
            serverUrl,
            {
                method: "POST",
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    "Content-Type": "application/json",
                    "x-session-token": sessionToken
                },
                body: JSON.stringify(body)
            }
        )
        return await playerReportByTime.json();
    } catch (errors) {
        return genericError(1000, errors)
    }
}